import { render, staticRenderFns } from "./merge.vue?vue&type=template&id=67d86f4e&scoped=true&"
import script from "./merge.vue?vue&type=script&lang=js&"
export * from "./merge.vue?vue&type=script&lang=js&"
import style0 from "./merge.vue?vue&type=style&index=0&id=67d86f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d86f4e",
  null
  
)

export default component.exports